import { cx } from '@linaria/core';
import { mdiWhiteBalanceSunny } from '@mdi/js';
import Icon from '@mdi/react';
import { ColorScheme } from '../../constants/enums';
import IconButton from '../Buttons/IconButton';
import { useColorScheme } from '../Hooks/useColorScheme';
import DarkMode from '../Icons/DarkMode';
import "./DarkModeToggle.linaria.module.css!=!./DarkModeToggle?./DarkModeToggle.linaria.module.css?css=H4sIAAAAAAAAA41TXW+jMBB876/g5aRWOldAgBD6cvdLLOMvDAvmbAdIUP/7SUlpMXcqeWPWM7PaneWVuBbHDEdZk7f99OrDuSS0kUafO4aoBm2KgZhndP9Glla85ciOytEKOUNo8/L2/nTzSGscOSrrVM6lNowbZAhTZ1vEST8tpJPFkZtGNcDMlO2BXAoB/PMZNL5USVgKH809YUx1EjndF/GXG3CPzrf0UjunW0/ReIpmqwAunMcHjw9bvlGy8gQHgRXrhUw+llCE6/1o+0fHw2Y/URj+WMmjRADwcNFH/RRYDYoF9yBW+Rg+cGP5ZwJHwGq4MDjO6+S+EVCL8+4QxaWPZqE7h0Z+m63UwBa+VJgLoON1bomRqivCYDU6zbFhuj7nPrq7WXXlxemLXE44Orq0rdwG3umCtAouxW+jCPy0pLPIcqPEohYGJ7XMT+kM3DlukO0JVZ0sOm1aAm/vT79azhQJnlsyoVExVxXBKQv76WW+GYyHmCbpOtudyr8nuNsjEmNv+HltuVv67+nud8qyydWAVTy6JHms5J989lCfarhek3LtuVPZ/CcfXW68JNxc+jLyYwf/F+6aZJ7GBAAA"
const rootStyles = "atm_2d_16k8mpx atm_5j_1tcgj5g atm_9s_1txwivl";
const buttonStyles = "atm_lo_yh40bf atm_le_yh40bf atm_lk_yh40bf atm_ll_yh40bf atm_3f_idpfg4";
const iconStyles = "atm_5j_1osqo2v atm_lo_yh40bf atm_le_yh40bf atm_lk_yh40bf atm_ll_yh40bf";
const iconSelectedStyles = "atm_3f_14flle0";
const autoStyles = "atm_7l_ivydl7 atm_cs_8n312b atm_gi_eflcwz atm_c8_rdoju8 atm_bx_17t5mht atm_fr_4jg895 atm_3f_idpfg4 atm_lo_yh40bf atm_le_yh40bf atm_lk_yh40bf atm_ll_yh40bf atm_w32c45_yh40bf atm_1fwpreu_yh40bf atm_166xtjl_i2wt44 atm_hvzz4b_i2wt44";
const autoSelectedStyles = "atm_40_14flle0";
interface DarkModeToggleProps {
  container: string;
  testid?: string;
  styleOverrides?: string;
}
const DarkModeToggle = (props: DarkModeToggleProps) => {
  const {
    container,
    testid = 'Toggle__DarkMode',
    styleOverrides
  } = props;
  const [colorScheme, changeColorScheme] = useColorScheme(container);
  return <div data-testid={testid} className={cx(rootStyles, styleOverrides)}>
            <IconButton onClick={() => changeColorScheme(ColorScheme.light)} title="Light Mode" name="Light Mode" className={buttonStyles}>
                <Icon path={mdiWhiteBalanceSunny} size={5 / 6} className={cx(iconStyles, colorScheme === ColorScheme.light && iconSelectedStyles)} />
            </IconButton>
            <IconButton onClick={() => changeColorScheme(ColorScheme.system)} title="System Default" name="System Default" className={autoStyles}>
                <span className={cx(colorScheme === ColorScheme.system && autoSelectedStyles)}>
                    AUTO
                </span>
            </IconButton>
            <IconButton onClick={() => changeColorScheme(ColorScheme.dark)} title="Dark Mode" name="Dark Mode" className={buttonStyles}>
                <DarkMode size="20px" className={cx(iconStyles, colorScheme === ColorScheme.dark && iconSelectedStyles)} />
            </IconButton>
        </div>;
};
export default DarkModeToggle;